import {Master} from './master';

export class Cari {

  id: number = null;
  cariKodu: string = '';
  firmaUnvani: string = '';
  yetkiliKisi: string = '';
  mailAdresi: string = '';
  cCMailAdresler: string = '';
  firmaAdresi: string = '';
  sehirId: number = null;
  ilce: string = '';
  telefon: string = '';
  cepTelefon: string = '';
  faks: string = '';
  vergiDairesi: string = '';
  vergiNo: string = '';
  tcNo: string = '';
  ibanNo: string = '';
  sehir: Master;
  vadeGunu: string;
  publicAccessKey: string;
  epostaGonder = true;
  isFaturaKesilsin: boolean = false;
  isOnayaGonderildi: boolean = false;
  isAktarildi: boolean = false;
  gorselGoster = true;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.sehir != null) {
      this.sehir = new Master(obj.sehir);
    }
  }

}
